import { render, staticRenderFns } from "./ServiceArticle.vue?vue&type=template&id=2912f352&"
import script from "./ServiceArticle.vue?vue&type=script&lang=js&"
export * from "./ServiceArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports